import { jsx } from "react/jsx-runtime";
import styled from "styled-components";
function DragRange({
  max,
  min,
  onKeyDown,
  onMouseDown,
  value
}) {
  function getPercentage(val) {
    return (val - min) / (max - min) * 100;
  }
  return /* @__PURE__ */ jsx(StyledDragRange, {
    $left: getPercentage(value[0]),
    $width: getPercentage(value[1]) - getPercentage(value[0]),
    "aria-valuemin": min,
    "aria-valuemax": max,
    "aria-valuetext": `${value[0]} - ${value[1]}`,
    "data-testid": "ds-slider-drag-range",
    onKeyDown,
    onMouseDown,
    tabIndex: 0
  });
}
const StyledDragRange = styled.div.withConfig({
  displayName: "StyledDragRange",
  componentId: "sc-nihmrp-0"
})(["position:absolute;left:", "%;width:", "%;height:100%;cursor:pointer;"], ({
  $left
}) => $left, ({
  $width
}) => $width);
export {
  DragRange
};
//# sourceMappingURL=DragRange.js.map
